import Vue from 'vue';
import Vuex from 'vuex';
import Router from 'vue-router';
import { setupComponentsFiltersDirectivesAndMixins, storeAsync, routerAsync } from './app-module';
import App from './App.vue';

import ApiService from './shared/services/api.service';
// import MockService from './core/mock/mock.service';
import '@/shared/utils/notify';
import '@/shared/utils/alert';
import { renderInApp } from './core/helpers/globalMethods';
import { setupArcgisLogging } from '@/shared/config/arcgis-log-config';

// Vue 3rd party plugins
import i18n from '@/shared/plugins/vue-i18n';
import '@/shared/plugins/portal-vue';
import '@/shared/plugins/bootstrap-vue';
import '@/shared/plugins/perfect-scrollbar';
import '@/shared/plugins/inline-svg';
import '@/shared/plugins/metronic';
import '@/shared/plugins/formvalidation';
import '@/shared/plugins/columns-resizable';

import { L10n, registerLicense } from '@syncfusion/ej2-base';
import { RO_EDITOR_LOCALE } from '@/shared/config/document-editor-locale-ro';
// TO DO: Add license key
registerLicense('license key');
// Romanian locale for the Syncfusion document editor (ribbon, dialogs, menus); vendored from ej2-locale.
L10n.load({ ro: RO_EDITOR_LOCALE });


// API service init
ApiService.init();

// ArcGIS console log level per environment.
setupArcgisLogging();

// TODO: Remove this to disable mock API
// MockService.init();

Vue.use(Router);
Vue.config.productionTip = process.env.NODE_ENV === 'production';
Vue.use(Vuex);
setupComponentsFiltersDirectivesAndMixins();

Vue.prototype.$renderInApp = renderInApp();

new Vue({
    store: storeAsync(),
    router: routerAsync(),
    i18n,
    data: {
        renderInApp: renderInApp(),
    },
    render: (h) => h(App),
}).$mount('#app');
